// extracted by mini-css-extract-plugin
export default {"root":"_3LjyJ","btnContainer":"_15y7E","icon":"_30pwQ"};